function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h3',[_c('strong',[_vm._v("Call center")])]),_vm._v(" "),_c('p',[_vm._v("Travel Agencies, Financial Services, Professional Services")]),_vm._v(" "),_c('h3',[_vm._v("Measure real ROI of marketing")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Optimise online advertising costs")]),_vm._v(" "),_c('li',[_vm._v("Improve retargeting")]),_vm._v(" "),_c('li',[_vm._v("Improve call center messaging/script")]),_vm._v(" "),_c('li',[_vm._v("Optimise call center performance")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/use-cases/call-center","image":"/img/use-cases/u-02.svg","title":"Call center"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }